export const categories = [
  { id: 'remenzixun', name: '热门资讯', icon: 'ri-fire-line', slug: 'remenzixun' },
  { id: 'chigua', name: '吃瓜事件', icon: 'ri-emotion-line', slug: 'chigua' },
  { id: 'keji', name: '科技数码', icon: 'ri-smartphone-line', slug: 'keji' },
  { id: 'shenghuo', name: '生活百科', icon: 'ri-lightbulb-line', slug: 'shenghuo' },
  { id: 'yule', name: '娱乐八卦', icon: 'ri-movie-2-line', slug: 'yule' },
  { id: 'caijing', name: '财经商业', icon: 'ri-line-chart-line', slug: 'caijing' },
  { id: 'jiaoyu', name: '教育学习', icon: 'ri-book-open-line', slug: 'jiaoyu' },
  { id: 'jiankang', name: '健康养生', icon: 'ri-heart-pulse-line', slug: 'jiankang' },
];

export const quickLinks = [
  { name: '百度', url: 'https://www.baidu.com', icon: 'ri-search-eye-line', color: 'primary' },
  { name: '新浪微博', url: 'https://weibo.com', icon: 'ri-weibo-line', color: 'accent' },
  { name: '知乎', url: 'https://www.zhihu.com', icon: 'ri-question-answer-line', color: 'secondary' },
  { name: 'B站', url: 'https://www.bilibili.com', icon: 'ri-bilibili-line', color: 'primary' },
  { name: '抖音', url: 'https://www.douyin.com', icon: 'ri-tiktok-line', color: 'accent' },
  { name: '淘宝', url: 'https://www.taobao.com', icon: 'ri-shopping-bag-3-line', color: 'secondary' },
  { name: '京东', url: 'https://www.jd.com', icon: 'ri-shopping-cart-2-line', color: 'primary' },
  { name: '网易新闻', url: 'https://news.163.com', icon: 'ri-newspaper-line', color: 'accent' },
  { name: '腾讯视频', url: 'https://v.qq.com', icon: 'ri-tv-2-line', color: 'secondary' },
  { name: 'GitHub', url: 'https://github.com', icon: 'ri-github-line', color: 'primary' },
  { name: '百度地图', url: 'https://map.baidu.com', icon: 'ri-map-pin-line', color: 'accent' },
  { name: '网易云音乐', url: 'https://music.163.com', icon: 'ri-music-2-line', color: 'secondary' },
];